<template>
  <b-container fluid>
    <b-modal id="freigabeModal" :title="dialogTitle" size="xl">
      <b-container fluid v-if="state === 'approval' && selectedPaket.text[$i18n.locale]" class="mb-4">
        <div v-html="selectedPaket.text[$i18n.locale]"></div>
      </b-container>
      <!-- Freigaben -->
      <b-container fluid v-if="state === 'approval' && hasOrgs" class="mb-4">
        <div v-html="selectedPaket.approval.text[$i18n.locale]"></div>
        <div v-for="(orgX, indx) in organisations" v-bind:key="indx">
          <b-form-checkbox
              class="col-10"
              v-model="selectedPaket.organisationen[indx].freigabe"
              :id="'org' + orgX.orgid"
              :disabled="orgX.disabled"
              v-on:change="freigabeChanged(orgX.orgid, indx)"
          >
            {{ orgX.organisation }}
            <span v-if="orgX.von.length">({{ $t("Seit").toLowerCase() }} {{ convertTime(orgX.von) }})</span>
          </b-form-checkbox>
        </div>
      </b-container>
      <!-- AGB -->
      <b-container fluid class="mb-4">
        <div v-html="termsText"></div>
      </b-container>
      <b-container fluid v-if="state === 'approval'" class="mb-4">
        <b-form-checkbox
            id="terms"
            v-model="terms"
            name="terms"
            value="accepted"
            unchecked-value="not_accepted">
          <span v-html="selectedPaket.terms.box[$i18n.locale]"></span>
        </b-form-checkbox>
      </b-container>
      <b-container fluid v-if="state === 'approval'">
        <b-alert show v-if="terms === 'not_accepted'" variant="danger">{{
            selectedPaket.terms.nok[$i18n.locale]
          }}
        </b-alert>
      </b-container>
      <div slot="modal-footer">
        <b-button
            v-on:click="close"
            v-if="state === 'approval'"
            variant="secondary"
        >{{ $t("Abbrechen") }}
        </b-button>
        <b-button
            v-on:click="close"
            v-if="state !== 'approval'"
            variant="secondary"
        >{{ $t("close") }}
        </b-button>
        &nbsp;
        <b-button
            type="button"
            v-if="state === 'approval'"
            :disabled="terms === 'not_accepted'"
            v-on:click="save"
            variant="primary"
        >{{ $t("Speichern") }}
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import moment from "moment";
import {bus, i18n} from "../../main";

export default {
  name: "FreigabeDialog",
  data() {
    return {
      paketId: 0,
      paketArrRef: 0,
      terms: "not_accepted",
      state: "loading", // approval, saving, saved, error
    };
  },
  computed: {
    selectedPaket() {
      return this.$store.state.datenpaketeStore.pakete[this.paketArrRef];
    },
    hasOrgs() {
      return Array.isArray(this.selectedPaket.organisationen);
    },
    organisations() {
      return this.hasOrgs ? this.selectedPaket.organisationen : [];
    },
    dialogTitle() {
      let title = "";
      if (this.state === "loading") {
        title = '...';
      } else if (this.state === "approval") {
        title = this.selectedPaket.terms.title[i18n.locale];
      } else {
        title = this.selectedPaket.save.title[i18n.locale];
      }
      return title;
    },
    termsText() {
      switch (this.state) {
        case "approval":
          return this.selectedPaket.terms.text[i18n.locale];
        case "saving":
          return this.selectedPaket.save.text[this.$i18n.locale];
        case "saved":
          return this.selectedPaket.save.ok[this.$i18n.locale];
        case "error":
          return this.selectedPaket.save.nok[this.$i18n.locale];
        default:
          return "unknown state (" + this.state + ")";
      }
    },
  },
  methods: {
    initModal(paketId) {
      this.paketId = paketId;
      this.paketArrRef = this.$store.state.datenpaketeStore.pakete.findIndex(
          (pkt) => pkt.id === paketId
      );
      this.terms = "not_accepted";
      this.state = "approval";
      this.$root.$emit("bv::show::modal", "freigabeModal");
      this.$root.$emit("bv::modal::show", "freigabeModal");
    },
    freigabeChanged(orgid, indx) {
      this.$store.dispatch("setFreigabeChanged", {orgid: orgid, indx: indx});
    },
    save() {
      this.state = "saving";
      this.$store.dispatch("savePaket", {id: this.paketId, declaration: false, approval: true});
    },
    async saveInProgressDone(savedPaketID, errorMsg) {
      if (savedPaketID !== this.paketId) return;
      if (typeof errorMsg == "string" && errorMsg.length > 0) {
        this.state = "error";
      } else {
        this.state = "saved";
      }
    },
    close() {
      this.wizardStep = 0;
      this.$root.$emit("bv::hide::modal", "freigabeModal");
    },
    convertTime(value) {
      return moment(value).format("DD.MM.YYYY");
    },
  },
  created() {
  },
  mounted() {
    let self = this;
    this.$root.$on("freigabeDialog", (paketId) => {
      self.initModal(paketId);
    });
    bus.$on("paketSaved", self.saveInProgressDone);
  },
  updated() {
  },
};
</script>

<style scoped>
.active {
  font-weight: bold;
}
</style>
